import { useShopGenderCookie } from '~/composables/useShopGenderCookie'

export const useTopNavigationMenu = () => {
  const { cookie, oldCookieValue, updateCookie } = useShopGenderCookie()

  return {
    currentMenu: cookie,
    previousMenu: oldCookieValue,
    setCurrentMenu: updateCookie,
  }
}
